import React from "react";
import { Card } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import CreateSessionReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import "./contract-search.scss";
import SearchStringOrIntReq2 from "Classes/Models/Requests/SearchStringOrIntReq";

const ContractSessionsTable = ({ Contract, setIsLoaded }) => {
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: "Name", accessor: "Name", align: "left" },
    { Header: "Egyptian Price", accessor: "EgyptianPrice", align: "left" },
    { Header: "Arab Price", accessor: "ArabPrice", align: "left" },
    { Header: "Other Price", accessor: "OtherPrice", align: "left" },
    { Header: "Update", accessor: "Update", align: "left" },
    { Header: "Remove", accessor: "Remove", align: "left" },
  ];
  const [TableDataRows, setTableDataRows] = useState([]);

  const DeleteSession = async (id) => {
    let SearchStringOrIntReq = new SearchStringOrIntReq2();

    SearchStringOrIntReq.SearchInt = id;
    var res = await SessionsApi.DeleteSession(SearchStringOrIntReq);

    if (res.status == "Success") {
      setIsLoaded(false);
      Swal.fire("Removed!", "The Session has been removed.", "success");
    } else {
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  };
  const UpdateContractSession = async (Session) => {
    let updateSessionReq = new CreateSessionReq();

    updateSessionReq.ArabPrice = document.getElementById(
      `contractSession${Session.id}ArabPrice`
    ).value;
    updateSessionReq.EgyptianPrice = document.getElementById(
      `contractSession${Session.id}EgyptainPrice`
    ).value;
    updateSessionReq.OtherPrice = document.getElementById(
      `contractSession${Session.id}OtherPrice`
    ).value;
    updateSessionReq.Category = Session.category;
    updateSessionReq.Description = Session.description;
    updateSessionReq.Id = Session.id;
    updateSessionReq.SecretName = Session.secretName;
    updateSessionReq.Name = Session.name;
    updateSessionReq.IsAssessmentSession = Session.isAssessmentSession;
    updateSessionReq.IsHalfDuration = Session.isHalfDuration;
    updateSessionReq.IsContractSession = Session.isContractSession;

    var res = await SessionsApi.EditSession(updateSessionReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session Updated Successfully",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const MakeTableRow = (Session) => {
    console.log(Session);
    return {
      Name: (
        <MDTypography
          className="input-data"
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {Session.name}
        </MDTypography>
      ),

      EgyptianPrice: (
        <MDInput
          className="input-data"
          type="number"
          defaultValue={Session.egyptianPrice}
          id={`contractSession${Session.id}EgyptainPrice`}
        />
      ),

      ArabPrice: (
        <MDInput
          className="input-data"
          type="number"
          defaultValue={Session.arabPrice}
          id={`contractSession${Session.id}ArabPrice`}
        />
      ),

      OtherPrice: (
        <MDInput
          className="input-data"
          type="number"
          defaultValue={Session.otherPrice}
          id={`contractSession${Session.id}OtherPrice`}
        />
      ),

      Update: (
        <button className="btn btn-outline-success" onClick={() => UpdateContractSession(Session)}>
          Update
        </button>
      ),
      Remove: (
        <button className="btn btn-outline-warning" onClick={() => DeleteSession(Session.id)}>
          Remove
        </button>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((Patient, index) => {
      rows.push(MakeTableRow(Patient, index));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (Contract.getContractSessions.length > 0) {
      RefreshTable(Contract.getContractSessions);
    } else {
      return (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          No Sessions
        </MDTypography>
      );
    }
  }, [Contract]);

  return (
    <Card className="mt-5">
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography
          variant="h6"
          color="white"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          Contract Sessions
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
};

export default ContractSessionsTable;
